let INTERVAL_ID = 0
let totalSeconds
let seconds
let minutes
let hours
let formattedTime

const storedTime = JSON.parse(localStorage.getItem('timeElapsed'))

if (storedTime) {
  totalSeconds = storedTime.totalSeconds
  seconds = storedTime.seconds
  minutes = storedTime.minutes
  hours = storedTime.hours
  formattedTime = storedTime.formattedTime
} else {
  totalSeconds = 0
  seconds = '00'
  minutes = '00'
  hours = '00'
  formattedTime = `${hours}:${seconds}:${minutes}`
}

const $timeElapsed = $('#TimeElapsed')
const $timeElapsedWrap = $('#TimeElapsedWrap')
const COUNTER_ACTIVE_CLASS = 'time-elapsed--is-active'
const COUNTER_RESETTING_CLASS = 'time-elapsed--is-resetting'

export default { start, stop }

function start() {
  INTERVAL_ID = setInterval(function() {
    totalSeconds = totalSeconds + 1
    seconds = leftpad(totalSeconds % 60, 2, 0)
    minutes = leftpad(Math.floor(Number(totalSeconds / 60)) % 60, 2, 0)
    hours = leftpad(Math.floor(Number(totalSeconds / 3600)), 2, 0)
    formattedTime = `${hours}:${minutes}:${seconds}`

    localStorage.setItem('timeElapsed', JSON.stringify({ totalSeconds, seconds, minutes, hours, formattedTime }))
    $timeElapsed.text(formattedTime)
    $timeElapsedWrap.addClass(COUNTER_ACTIVE_CLASS)
  }, 1000)

  $timeElapsedWrap.one('dblclick', (event) => {
    let TIMEOUT_ID = 0
    clearTimeout(TIMEOUT_ID)
    if (window.confirm("RESET TIME?")) {
      stop()
      $timeElapsedWrap.addClass(COUNTER_RESETTING_CLASS)
      TIMEOUT_ID = setTimeout(() => {
        start()
        $timeElapsedWrap.removeClass(COUNTER_RESETTING_CLASS)
      }, 700)
    }
  })
}

function stop() {
  clearInterval(INTERVAL_ID)
  totalSeconds = 0
  seconds = '00'
  minutes = '00'
  hours = '00'
  formattedTime = `${hours}:${minutes}:${seconds}`
  localStorage.removeItem('timeElapsed')
  localStorage.setItem('timeElapsed', JSON.stringify({ totalSeconds, seconds, minutes, hours, formattedTime }))
  $timeElapsed.text(formattedTime)
  $timeElapsedWrap.removeClass(COUNTER_ACTIVE_CLASS)
}

function leftpad (str, len, ch) {
  str = String(str)
  let i = -1
  if (!ch && ch !== 0) {
    ch = ' '
  }
  len = len - str.length
  while (++i < len) {
    str = ch + str
  }
  return str
}



// WEBPACK FOOTER //
// ./time-elapsed.js